import { useMaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CustomTable } from 'src/presentations/components/molecules/table/Table';
import { ShipmentChargeDto } from 'src/generated/services/TFinancialApi';
import { beautifyEnum, formatMoney } from 'src/utils/utility';

export const TableMain = styled(Box)({
  '.MuiTableCell-head:first-of-type': {
    width: '40px',
  },
});

const useRateCardShipmentColumns = (): MRT_ColumnDef<ShipmentChargeDto>[] => {
  const columns = [
    {
      accessorKey: 'legType',
      header: 'Leg',
      enableEditing: false,
      accessorFn: (row: ShipmentChargeDto) => <span className='capitalize'>{beautifyEnum(row?.legType)}</span>,
    },
    {
      accessorKey: 'chargeName',
      header: 'Charge Name / Charge Category',
      enableEditing: false,
      accessorFn: (row: ShipmentChargeDto) => (
        <span className='capitalize'>
          {beautifyEnum(row?.chargeName)} / {beautifyEnum(row?.chargeCategory)}
        </span>
      ),
    },
    {
      accessorKey: 'unitPrice',
      header: 'Rate Card Unit Price',
      enableEditing: false,
      accessorFn: (row: ShipmentChargeDto) => <span className='capitalize'>{formatMoney(row?.unitPrice, row?.currency)}</span>,
    },
  ];
  return columns;
};

export interface ITableRateCardChargeProps {
  data: ShipmentChargeDto[];
}

export const TableRateCardShipment = ({ data }: ITableRateCardChargeProps) => {
  const columns = useRateCardShipmentColumns();

  const table = useMaterialReactTable({
    data,
    enableRowNumbers: false,
    enableSorting: false,
    enablePinning: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enablePagination: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableEditing: false,
    editDisplayMode: 'table',
    muiTableHeadProps: {
      sx: {
        '& .MuiTableCell-head': {
          '&:first-of-type': {
            width: '100px',
            textAlign: 'center',
          },
        },
      },
    },
    columns,
  });
  return <CustomTable table={table} />;
};
